export const categories = [
  {
    id: "entertainment",
    name: "娱乐八卦",
    icon: "ri-chat-smile-2-line",
    groupCount: 5,
    desc: "娱乐圈动态、事件时间线、理性讨论，是吃瓜群最主流的方向。",
    keywords: ["娱乐八卦", "娱乐圈动态", "时间线整理"],
  },
  {
    id: "drama",
    name: "影视追剧",
    icon: "ri-movie-2-line",
    groupCount: 3,
    desc: "新剧开播、片单安利、综艺名场面，追剧党边看边聊的主阵地。",
    keywords: ["影视追剧", "片单安利", "综艺讨论"],
  },
  {
    id: "influencer",
    name: "网红热点",
    icon: "ri-live-line",
    groupCount: 2,
    desc: "短视频与直播圈动态，创作者生态、同款穿搭一网打尽。",
    keywords: ["网红热点", "直播动态", "短视频圈"],
  },
  {
    id: "life",
    name: "生活趣事",
    icon: "ri-emotion-happy-line",
    groupCount: 2,
    desc: "治愈系分享、搞笑表情包，想放松心情、远离争吵就来这里。",
    keywords: ["生活趣事", "搞笑分享", "治愈日常"],
  },
  {
    id: "news",
    name: "时事热点",
    icon: "ri-newspaper-line",
    groupCount: 3,
    desc: "社会热点与热搜观察，强调来源与多方观点，克制不引战。",
    keywords: ["时事热点", "热搜观察", "多方观点"],
  },
  {
    id: "gaming",
    name: "游戏电竞",
    icon: "ri-gamepad-line",
    groupCount: 1,
    desc: "赛事实时讨论、战队动态、比赛复盘，电竞爱好者的加群首选。",
    keywords: ["游戏电竞", "赛事讨论", "战队动态"],
  },
];